// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-light .geoTable {
  width: 100%;
  max-width: 800px;
  margin: 20px auto;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  color: #000;
}
.theme-light .geoTable table {
  width: 100%;
  border-collapse: collapse;
}
.theme-light .geoTable table th, .theme-light .geoTable table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
}
.theme-light .geoTable table th {
  background-color: white;
  font-weight: bold;
}
.theme-light .geoTable table tr:nth-child(even) {
  background-color: #f6f3f3;
}
.theme-dark .geoTable {
  width: 100%;
  max-width: 800px;
  margin: 20px auto;
  border-collapse: collapse;
  font-family: Arial, sans-serif;
  color: #fffef9;
}
.theme-dark .geoTable table {
  width: 100%;
  border-collapse: collapse;
}
.theme-dark .geoTable table th, .theme-dark .geoTable table td {
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: left;
}
.theme-dark .geoTable table th {
  background-color: #222;
  font-weight: bold;
}
.theme-dark .geoTable table tr:nth-child(even) {
  background-color: #333;
}`, "",{"version":3,"sources":["webpack://./src/style.scss","webpack://./src/components/geo/geoTable.scss"],"names":[],"mappings":"AAqBI;ECjBA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,8BAAA;EACA,WAAA;AAFJ;AAII;EACE,WAAA;EACA,yBAAA;AAFN;AAIM;EACE,kBAAA;EACA,sBAAA;EACA,gBAAA;AAFR;AAKM;EACE,uBAAA;EACA,iBAAA;AAHR;AAMM;EACE,yBAAA;AAJR;ADFI;ECjBA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,8BAAA;EACA,cAAA;AAsBJ;AApBI;EACE,WAAA;EACA,yBAAA;AAsBN;AApBM;EACE,kBAAA;EACA,sBAAA;EACA,gBAAA;AAsBR;AAnBM;EACE,sBAAA;EACA,iBAAA;AAqBR;AAlBM;EACE,sBAAA;AAoBR","sourcesContent":["$themes: (\n  light: (\n    textColor: #000,\n    bg: white,\n    logo: #0B4855,\n    bgSoft: #f6f3f3,\n    textColorSoft: #555,\n    border: lightgray,\n  ),\n  dark: (\n    textColor: #fffef9,\n    bg: #222,\n    logo: rgb(78, 217, 113),\n    bgSoft: #333,\n    textColorSoft: #d1d0c9,\n    border: #444,\n  ),\n);\n\n@mixin themify($themes) {\n  @each $theme, $map in $themes {\n    .theme-#{$theme} & {\n      $theme-map: () !global;\n      @each $key, $submap in $map {\n        $value: map-get(map-get($themes, $theme), \"#{$key}\");\n        $theme-map: map-merge(\n          $theme-map,\n          (\n            $key: $value,\n          )\n        ) !global;\n      }\n      @content;\n      $theme-map: null !global;\n    }\n  }\n}\n\n@function themed($key) {\n  @return map-get($theme-map, $key);\n}\n\n@mixin mobile {\n  @media (max-width: 480px) {\n    @content;\n  }\n}\n@mixin tablet {\n  @media (max-width: 960px) {\n    @content;\n  }\n}\n","@import \"../../style.scss\";\n\n.geoTable{\n  @include themify($themes) {\n    width: 100%;\n    max-width: 800px;\n    margin: 20px auto;\n    border-collapse: collapse;\n    font-family: Arial, sans-serif;\n    color: themed(\"textColor\");\n  \n    table {\n      width: 100%;\n      border-collapse: collapse;\n  \n      th, td {\n        padding: 12px 15px;\n        border: 1px solid #ddd;\n        text-align: left;\n      }\n  \n      th {\n        background-color: themed(\"bg\");\n        font-weight: bold;\n      }\n  \n      tr:nth-child(even) {\n        background-color: themed(\"bgSoft\");\n      }\n  \n      tr:hover {\n        background-color: themed(\"bgSoftHover\");\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
